'use client'

import { PaginationSkeleton } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'

import VaultListingLayout from '../VaultListingLayout'

/** Over half of the most-visited markets list more than five vaults: a full first page and pagination. */
const VaultListingLoading = () => {
  return (
    <VaultListingLayout>
      <Skeleton className="h-[263px] w-[100%] rounded-[20px]" />
      <PaginationSkeleton />
    </VaultListingLayout>
  )
}

export default VaultListingLoading
